export const COLLAPSE_BREAKPOINT_PX = 1024

/**
 * Read the persisted navbar collapse state straight from localStorage
 * (ngrx-store-localstorage persists the `userSettings` slice under its own
 * key). Synchronous by design: used before the sidebar's first paint so a
 * restored collapse doesn't animate expanded -> collapsed on boot.
 */
export function readNavbarCollapsedFromLocalStorage(): boolean | null {
  try {
    const raw = localStorage.getItem('userSettings')
    if (!raw) return null
    const value = JSON.parse(raw)?.isNavBarCollapsed
    return typeof value === 'boolean' ? value : null
  } catch {
    return null
  }
}

/**
 * Read the persisted queue-panel collapse state straight from localStorage
 * (ngrx-store-localstorage persists the `userSettings` slice under its own
 * key). Synchronous by design: used before the inbox navbar's first paint so
 * a restored collapse doesn't animate expanded -> collapsed on boot.
 */
export function readQueuePanelCollapsedFromLocalStorage(): boolean | null {
  try {
    const raw = localStorage.getItem('userSettings')
    if (!raw) return null
    const value = JSON.parse(raw)?.isQueuePanelCollapsed
    return typeof value === 'boolean' ? value : null
  } catch {
    return null
  }
}
